import type { User } from "@/types/localstorage";

export const READ_ONLY_TOOLTIP_MESSAGE =
  "現在の権限では、ご利用いただけません。";

/**
 * 渡されたユーザーオブジェクトが読み取り専用ユーザーかどうかを判定します。
 * @param user ユーザー情報を含むオブジェクト、またはnullかundefined
 * @returns 読み取り専用の場合は`true`、それ以外は`false`を返します。
 */
export const isReadOnlyUser = (
  user: Partial<User> | null | undefined
): boolean => Boolean(user?.isReadOnly);
